import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-estimate-box',
  templateUrl: './estimate-box.component.html',
  styleUrls: ['./estimate-box.component.css'],
})
export class EstimateBoxComponent {
  historyState: any;
  @Input() isLoader: boolean = false;
  @Input() showBack: boolean = true;
  @Input() showForward: boolean = true;
  @Input() showSubmitBtn: boolean = true;
  @Input() submitBtnLabel: string = 'Submit';
  @Output() submitBtnClick = new EventEmitter<void>();
  @Output() backClick = new EventEmitter<void>();
  @Output() forwardClick = new EventEmitter<void>();
  showResList: boolean = false;

  ngOnInit(): void {
    this.historyState = history.state;
  }
  submitBtnonClick() {
    this.submitBtnClick.emit();
  }
  backButtonOnClick() {
    this.backClick.emit();
  }
  forwardOnClick() {
    this.forwardClick.emit();
  }
  toggleResClick() {
    this.showResList = !this.showResList;
  }
}
